export const DEVICE_SEARCH_FILTER_STORAGE_KEY = 'deviceSearchSavedFilters';
